<template>
	<div class="notice">
		<div class="information-hr"></div><div class="information-hr2"></div>
		<el-select v-model="sort" placeholder="排序" class='pai'>
	      <el-option label="时间降序" value="1"></el-option>
	      <el-option label="时间升序" value="2"></el-option>
	    </el-select>
	    <el-button type="primary" round @click.once="readAll">全部标为已读</el-button>
        <el-table align='center'  :data="items"
		    style="margin: 20px 10px 20px 0; width: 830px;">
		    <el-table-column align='center'  label="通知内容"  width="300">
		      <template slot-scope="scope">
		        <span @click="findThis(scope.$index, scope.row)" class="notice-info" v-html='scope.row.content'></span>
		      </template>
		    </el-table-column>
		    <el-table-column  label="对应投稿编号"  width="160" align='center'>
		      <template slot-scope="scope">
		      	{{ scope.row.num_order }}
		      </template>
		    </el-table-column>
		    <el-table-column  label="通知时间"  width="160" align='center'>
		      <template slot-scope="scope">
		        <span>{{ scope.row.created_at }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column  label="是否已读"  width="80" align='center'  >
		      <template slot-scope="scope">
		        <span :style="{color:scope.row.color}" v-if="scope.row.statusNum == '未读'"  @click="oneRead(scope.$index, scope.row)" class="notice-info">{{ scope.row.statusNum }}</span>
		        <span :style="{color:scope.row.color}" v-else>{{ scope.row.statusNum }}</span>
		      </template>
		    </el-table-column>
		    <el-table-column label="操作" width="80" align='center'>
		      <template slot-scope="scope">
		        <el-button type="danger" size="mini"  @click="delNotice(scope.$index, scope.row)">删除</el-button>
		      </template>
		    </el-table-column>
		  </el-table>

		<el-pagination class="fen" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next, jumper" :total="total" style="text-align: center;">
		</el-pagination>
		<div class="information-hr-bottom"></div><div class="information-hr2-bottom"></div>
	</div>
</template>

<script>
	import axios from 'axios'
	export default {
		data(){
			return{
				notHave:true,
				items:[],
				isActive:false,
				hasError:false,
				currentPage:1,
				sort:'',
				total:0,
				pageSize:8,
				page:1,
				activeColor:'gray'
			}
		},
		methods:{
			init(sort,page){
				var form = new FormData
				form.append('sort',sort)
				form.append('page',page)
				form.append('pageSize',this.pageSize)
				axios({
					method:'post',
					url:process.env.BASE_URL+'/notice/lists',
					data:form,
					withCredentials:true
				})
				.then(res =>{
					if (res.data.code == 10000) {
						this.total = res.data.data.total
						this.items = res.data.data.rows
						for (var i = 0; i < this.items.length; i++) {
							if (this.items[i].user_is_read == 0) {
								this.items[i].color = '#f00'
								this.items[i].notHave = false
								this.items[i].statusNum = '未读'
							} else if (this.items[i].user_is_read == 1){
								this.items[i].color = '#333'
								this.items[i].notHave = true
								this.items[i].statusNum = '已读'
							}

							if(this.items[i].type == 2){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”<span class="c-blue">有新的审核员留言</span>，赶紧点击查看吧！'
							}
							if(this.items[i].type == 3){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”<span class="c-red">初稿投递成功</span>，请耐心等待审核及后续通知，点击本消息可跳转至投稿详情页查看更多信息。'
							}
							if(this.items[i].type == 4){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”已<span class="c-green">开始初审</span>，点击本消息可跳转至投稿详情页查看更多信息。'
							}
							if(this.items[i].type == 5){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”已<span class="c-red">通过初审</span>，请您及时准备复审材料并尽快提交，点击本消息可跳转至投稿入口-提交复审材料界面'
							}
							if(this.items[i].type == 6){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”已<span class="c-red">收到复审材料</span>，请耐心等待审核及后续通知，点击本消息可跳转至投稿详情页查看更多信息。'
							}
							if(this.items[i].type == 7){
								this.items[i].content = '您的投稿作品“'+this.items[i].title+'”已<span class="c-green">开始复审</span>，点击本消息可跳转至投稿详情页查看更多信息。'
							}
							if(this.items[i].type == 8){
								this.items[i].content = '您的投稿作品“<span>'+this.items[i].title+'</span>”已<span class="c-red">通过复审</span>，工作人员将在近期联系您沟通投稿采纳相关事宜，请您保持手机等联系方式畅通，谢谢！'
							}
							if(this.items[i].type == 9){
								this.items[i].content = '您的投稿作品“<span>'+this.items[i].title+'</span>”<span class="c-blue">未通过审核</span>，请再接再厉！点击本消息可跳转至投稿详情页查看更多信息。'
							}
							
						}
					}					
				})
			},
			handleSizeChange(val) {
	         console.log(`每页 ${val} 条`);
	       },
	       handleCurrentChange(val) {	 
	       	    this.page = val
	        	if (this.sort == '') {
    				this.init(1,val)
    			} else{
    				this.init(this.sort,val)
    			}
	       },
	       delNotice(index,row){
	       	    this.$confirm('此操作将删除该通知, 是否继续?', '提示', {
		          confirmButtonText: '确定',
		          cancelButtonText: '取消',
		          type: 'warning'
		        }).then(() => {
		            var form2 = new FormData
			    	form2.append('id',row.id)
			    	axios({
			    		method:'post',
			    		url:process.env.BASE_URL+'/notice/delete',
			    		data:form2,
			    		withCredentials:true
			    	})
			    	.then(res=>{
			    		if(res.data.code == 10000){
			    			if (this.sort == '') {
			    				this.init(1,this.page)
			    			} else{
			    				this.init(this.sort,this.page)
			    			}
			    			this.$message({
					          message: '删除成功',
					          type: 'success'
					        });
			    		}else {
			    			this.$message(res.data.message)
			    		}
			    	})
		        }).catch(() => {
		            this.$message({
			            type: 'info',
			            message: '已取消删除'
			          });       
		        });	    	
		    },
		    findThis(index,row){//单条通知跳转
		    	if(row.type == 5){
		    		this.$store.commit('SET_ISPERSON', true)
					this.$store.commit('SET_ISLOGIN', false)
					this.$store.commit('SET_ISCENTER', true)
					this.$store.commit('SET_ISFIRST', false)
                    this.$router.push({path:'/review'})
		    	}else{
		    		this.$router.push({path:'/person/edit?id=' + row.aid + ''})		    		
		    		this.$store.commit('SET_ADMINLEFTNAVNUM','/person/edit?id='+ row.aid + '')
//		    		console.log(this.$store.state.adminleftnavnum)
		    		this.$store.commit('SET_ADMINLEFTNAVNUM','/person/information')
//		    		console.log(this.$store.state.adminleftnavnum)
		    	}
		    	this.oneRead(index,row)
		    },
		    oneRead(index,row){//单条已读
		    	axios({
		    		method:'post',
		    		url:process.env.BASE_URL+'/notice/read-one?id='+row.id+'',
		    		withCredentials:true,
		    	})
		    	.then(res =>{
		    		if(res.data.code == 10000){
		    			if (this.sort == '') {
		    				this.init(1,this.page)
		    			} else{
		    				this.init(this.sort,this.page)
		    			}
		    			
		    		}else {
		    			this.$message(res.data.message)
		    		}
		    	})
		    },

		    //全部已读
		    readAll(){
		    	axios({
		    		method:'post',
		    		url:process.env.BASE_URL+'/notice/read-all',
		    		withCredentials:true,
		    	})
		    	.then(res =>{
		    		if(res.data.code == 10000){
		    			if (this.sort == '') {
		    				this.init(1,this.page)
		    			} else{
		    				this.init(this.sort,this.page)
		    			}
		    			this.$message({
				          message: '全部已读成功',
				          type: 'success'
				        });
		    		}else {
		    			this.$message(res.data.message)
		    		}
		    	})
		    },
		    spread(item){
				this.$nextTick(function(){	
					if (item.change == true) {
						item.change = false					
					    this.items.push()
					} else if(item.change == false){
						item.change = true					
					    this.items.push()
					} else if(item.change == undefined){
						item.change = true
						this.items.push()
					}
				})
			},
		},
		created(){
			this.init(1,this.page)
		},
		watch:{
			sort:function(){
				this.init(this.sort,this.page)
			}
		}
	}
</script>

<style scoped>
	.notice{
		background: #FAFAFA;
		padding:25px 0 0 20px;
		height: auto !important; margin-top: -286px!important;
	}
	.div{
		background: white;
		box-shadow: 5px 5px 5px gray;
		position: relative;
		margin-top: 30px;
		width: 800px;
		height: 50px;
		margin-left: 20px;
	}
	.div .close{
		position: absolute;
		top: -10px;
		right: -10px;
	}
	.rightMsg{
		float:right;
		margin-top: -50px;
	}
	.noticeMsg{
		height: 50px;
		line-height: 50px;
		vertical-align: middle;
		padding-left: 20px;
	}
	.msgOver{
		width: 100%;
		display: -webkit-box;
	    -webkit-line-clamp: 1;
	    -webkit-box-orient: vertical;
	    overflow: hidden;
	    word-break: break-all;
	    cursor: pointer;
	}
	.fen{
		width: 520px;
		margin: 40px auto;
	}
	.pai{
		margin-left: 483px;
		padding-top: 0px;
	}
	.active{
		overflow: auto;
		display: block;
	}	
	.notice-info{ cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/views/notice.vue